import * as React from "react";
import { Text } from "office-ui-fabric-react";

export const CategoryHeader: React.FC<{ title: string }> = ({ title }) => {
  return (
    <>
      <br />
      <Text variant="medium">{title}</Text>
    </>
  );
};
